
import { getDateStringForDisplay } from '@@/bits/time'
import relativeTime from 'bits/relative_time'
import { Component, Prop, Vue } from 'bits/vue'

/**
 * Displays the duration relative to given date/time.
 */

@Component({})
export default class RelativeTime extends Vue {
  /**
   * Display the duration from this date/time.
   */
  @Prop() datetime!: string | number | Date

  /**
   * The format to display the relative time in.
   */
  @Prop({ default: 'short' }) dateformat!: 'short' | 'long'

  get relativeTime(): string {
    return relativeTime(this.datetime, this.dateformat)
  }

  get actualTime(): string {
    return getDateStringForDisplay(this.datetime)
  }
}
